
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_lljvd_1jk2l_1",
  "inTransition": "awsui_inTransition_lljvd_1jk2l_7",
  "transformed": "awsui_transformed_lljvd_1jk2l_12",
  "removed": "awsui_removed_lljvd_1jk2l_17",
  "dragged": "awsui_dragged_lljvd_1jk2l_21",
  "resized": "awsui_resized_lljvd_1jk2l_26",
  "hidden": "awsui_hidden_lljvd_1jk2l_31"
};
  